(function( $, nordsjo ){

    var searchResultsView = null,
        searchResults     = null,
        termsView         = null,
        searchTerm        = '',
        productCatCounts;

    var SearchResult  = Backbone.Model.extend({});
    var SearchResults = Backbone.Collection.extend({
        model: SearchResult
    });

    var SearchResultsView = Backbone.View.extend({
        initialize: function() {
            this.listenTo( this.collection, 'reset', this.render );
        },

        render: function() {
            var $resultListTemplate = $( document.getElementById( 'es-result-list-item-template' ) ).html(),
                $resultsList        = $( '<ul id="es-results-list" class="es-results-list" />' );

            if ( this.collection.length > 0 ) {
                this.collection.each( function( model ) {
                    var data = model.toJSON();
                    if ( typeof data.featured_image === 'undefined' ) {
                        data.featured_image = '';
                    }
                    if ( '' === data.post_excerpt ) {
                        if ( null !== data.post_content ) {
                            data.post_excerpt = data.post_content.substr( 0, 150 ) + '&hellip;';
                        }
                    }
                    var template = _.template( $resultListTemplate, data );
                    $resultsList.append( template );
                });
            } else {
                $resultsList.append( '<li>' + nordsjo.noResults + '</li>' );
            }

            if ( $( document.getElementById( 'es-search-results' ) ).length ) {
                $( document.getElementById( 'es-results-list-container' ) ).html( $resultsList );

                var link = nordsjo.homeUrl + '/search/' + encodeURIComponent( searchTerm );
                $( document.getElementById( 'search-link-page' ) ).attr( 'href', link );

            } else {
                var data = {
                    header    : nordsjo.searchSuggestions,
                    homeUrl   : nordsjo.homeUrl,
                    searchTerm: searchTerm,
                    searchText: nordsjo.searchText
                };
                var template = _.template( $( document.getElementById( 'es-result-template' ) ).html(), data );
                $( '.searchform-container' ).append( template ).find( $( '#es-results-list-container' ).html( $resultsList ) );
            }

            this.renderTermCounts();

            $( document.getElementById( 'es-search-results' ) ).height( $( window ).height() - 100 );

        },

        createTermObjects: function() {
            var terms = nordsjo.productCats;

            _.each( terms, function( term ) {
                if ( typeof productCatCounts[ term.slug ] === 'undefined' ) {
                    term.searchCount = 0;
                } else {
                    term.searchCount = productCatCounts[ term.slug ];
                }
            });

            return terms;
        },

        renderTermCounts: function() {
            var searchTerms = new Terms();
            _.each( this.createTermObjects(), function( term ) {
                searchTerms.add( term );
            });
            termsView = new TermsCountView({ collection: searchTerms });
            $( document.getElementById( 'term-results-list-container' ) ).html( termsView.$el );
        },

        reset: function() {
            $( '#es-results-list' ).empty();
            $( '.es-terms-list' ).empty();
        }

    });


    var Term = Backbone.Model.extend({});
    var Terms = Backbone.Collection.extend({
        model: Term
    });
    var TermsCountView = Backbone.View.extend({
        initialize: function() {
            this.render();
        },
        render: function() {
            var $termsTemplate = $( document.getElementById( 'es-result-list-terms-template' ) ).html(),
                $termsList     = $( '<ul class="es-terms-list" />' );

            if ( this.collection.length > 0 ) {
                this.collection.each( function( model ) {
                    var template = _.template( $termsTemplate, model.toJSON() );
                    $termsList.append( template );
                });
            }

            this.$el.append( $termsList );
        }
    });


    var SearchFieldView = Backbone.View.extend({
        searchTerm: '',
        url: nordsjo.elasticAjaxUrl,
        timer: null,
        events: {
            'keyup #s': 'inputChange',
            'focus #s': 'showDropdown',
            'blur #s' : 'maybeHideDropdown'
        },

        /** When the user types in some search text */
        inputChange: function( e ) {
            var self = this;
            searchTerm = $( e.currentTarget ).val();

            // Add a throttle to the requests.
            if ( null === this.timer ) {
                if ( searchTerm.length >= 1 ) {
                    this.timer = setTimeout( function() {
                        self.doQuery();
                        self.timer = null;
                    }, 250 );
                } else {
                    if ( null !== searchResultsView ) {
                        searchResultsView.reset();
                    }
                }
            }
        },

        doQuery: function() {
            var self            = this,
                productCatTerms = _.pluck( nordsjo.productCats, 'slug' ),
                data            = this.buildQueryParams(),
                taxData         = this.buildTaxQueryParams( productCatTerms ),
                searchQuery     = this.searchQuery( data ),
                taxQuery        = this.searchQuery( taxData );

            $.when( searchQuery, taxQuery ).done( function( data, taxData ) {
                // console.log( data, taxData );
                if ( data === null ) {
                    console.log( 'Unable to connect to elasticsearch server' );
                } else {
                    if ( typeof data.hits !== 'undefined' ) {
                        self.renderResults( data.hits.hits, taxData.hits.hits );
                    }
                }
            });
        },

        /**
         * Perform a search query.
         *
         * @param {object} params Object of args to override defaults.
         *
         * @return {object} result from the query.
         */
        searchQuery: function( data ) {
            var deferred = jQuery.Deferred();

            $.ajax({
                type: 'POST',
                url : this.url,
                data: {
                    search: data,
                    esUrl : nordsjo.elasticsearchUrl
                }
            }).done( function( result ) {
                // console.log( 'Result from Query: ', result );
                deferred.resolve( result );

            });

            return deferred.promise();
        },

        /**
         * Build the POST paramaters for an ES search.
         *
         * @param {object} params Object of args to override defaults.
         *
         * @return {object} POST args.
         */
        buildQueryParams: function( params ) {
            var args    = params || {},
                request = _.defaults( args, {
                    from: 0,
                    size: 5,
                    query: {
                        bool: {
                            must: [
                                {
                                    fuzzy_like_this: {
                                        fields: [ '_all' ],
                                        like_text: searchTerm,
                                        min_similarity: 0.6
                                    }
                                }
                            ]
                        }
                    }
                });

            return JSON.stringify( request );
        },

        buildTaxQueryParams: function( taxonomies ) {
            var args = {
                from: 0,
                size: 1000,
                fields: ["terms.product_cat.slug"],
                query: {
                    bool: {
                        must: [
                            {
                                fuzzy_like_this: {
                                    fields: ["_all"],
                                    like_text: searchTerm,
                                    min_similarity: 0.6
                                }
                            }
                        ]
                    }
                },
                filter: {
                    and: [
                        {
                            bool: {
                                must: [
                                    {
                                        terms: {
                                            "terms.product_cat.slug": taxonomies
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            term: {
                                "post_type.raw": ["product"]
                            }
                        }
                    ]
                }
            };

            return JSON.stringify( args );
        },

        /**
         * Render the results from an ES search.
         *
         * @param {array} Search esults from ES.
         */
        renderResults: function( hits, taxData ) {
            var models = [],
                i;

            for ( i = 0; i < hits.length; i++ ) {
                models.push( hits[i]._source );
            }

            var productCats = {};
            _.each( taxData, function( data ) {
                var slug = data.fields["terms.product_cat.slug"];
                productCats[ slug ] = productCats[ slug ] ? productCats[ slug ] + 1 : 1;
            });
            productCatCounts = productCats;

            if ( null === searchResults ) {
                searchResults = new SearchResults();
            }

            searchResults.reset( models );

            if ( searchResultsView === null ) {
                searchResultsView = new SearchResultsView({ collection: searchResults });
            }

        },

        showDropdown: function() {
            $( '.searchform-container' ).addClass( 'es-search-active' );
        },

        maybeHideDropdown: function() {
            $( '.searchform-container' ).removeClass( 'es-search-active' );
        }

    });

    $( function() {
        $( '#s' ).attr( 'autocomplete', 'off' );

        if ( typeof nordsjo.elasticsearchUrl !== 'undefined' ) {
            new SearchFieldView({ el: $( 'form#searchform' ) });
        }

    });

})( jQuery, window.nordsjo );
